// extracted by mini-css-extract-plugin
export var imageContainer = "UqcrF";
export var imageGalleryWidth = "zMWwe";
export var videoCardMaxHeight = "Lf7TC";